import { FC, useEffect, useState } from 'react';
import { observer, saveAs } from '~/modules';
import {
  EventTypes,
  getClientDetailedInfo,
  getMetadataItemByKey,
  showAlert,
  useStores,
} from '~/utils';
import AuditDetails from './AuditDetails';

export const AuditDetailsContainer: FC = () => {
  const {
    audit: {
      client,
      currentLog,
      mergeTransactionToLogMetadata,
      downloadDetailedLog,
    },
  } = useStores();

  const [loading, setLoading] = useState(false);
  const [accountId] = useState(() =>
    getMetadataItemByKey('account_id', currentLog.metadata),
  );
  const [eventId] = useState(() =>
    getMetadataItemByKey('event_id', currentLog.metadata),
  );

  const fetchTransactionDetails = async () => {
    try {
      setLoading(true);
      if (accountId?.value && eventId?.value) {
        await mergeTransactionToLogMetadata({
          accountId: accountId.value,
          transactionId: eventId.value,
        });
      }
    } catch ({ message }) {
      showAlert({ message });
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadDetailedLog = async () => {
    try {
      const response = await downloadDetailedLog({
        document: client.document,
        logId: currentLog.id,
        eventId: eventId?.value,
        accountId: accountId?.value,
      });
      const filename = response.headers
        .get('Content-Disposition')
        .split(';')
        .find((n) => n.includes('filename='))
        .replace('filename=', '')
        .trim();
      saveAs(response.data, filename);
    } catch ({ message }) {
      showAlert({ message });
    }
  };

  useEffect(() => {
    if (currentLog.eventType === EventTypes.BENEFITS) {
      fetchTransactionDetails();
    }
  }, []);

  return (
    <AuditDetails
      clientName={client.fullName}
      isClientAppAccessBlocked={client.isAppAccessBlocked}
      clientDetailedInfo={getClientDetailedInfo(client)}
      onDownloadDetailedLog={handleDownloadDetailedLog}
      log={currentLog}
      loading={loading}
    />
  );
};

export default observer(AuditDetailsContainer);
